import React from 'react';
import useMain from '../../../../hooks/useMain';
import { capitalize } from 'lodash';
import { numberWithCommas } from '../../../../utils/helpers';
import Image from './../../../common/image';

const CardsList = () => {
	const { initData } = useMain();
	const { cards } = initData;

	const plannerCards = Object.values(cards).filter(
		(card) => card.type === 'planner' && card.sellIsOpen
	);
	const investmentCards = Object.values(cards).filter(
		(card) => card.type === 'investor' && card.sellIsOpen
	);

	return (
		<div className='mb-4 card myCards'>
			<div className='card-body'>
				<div className='row text-center gy-5 mt-4'>
					<div className='col-12'>
						<div className='fw-bold fs-3'>Investor Packages</div>
					</div>
					<div className='offset-md-1 col-md-10 col-12'>
						<div className='table-responsive'>
							<table className='table table-sm myTable text-center'>
								<thead>
									<tr>
										<th></th>
										<th>Card</th>
										<th>Amount</th>
										<th>Staking Profit</th>
										<th>Max Cap</th>
										<th>Sell Limit</th>
										<th>Withdraw Limit</th>
										<th>Transfer Limit</th>
									</tr>
								</thead>
								<tbody>
									{investmentCards.map((card, key) => (
										<tr key={key}>
											<td>
												<Image
													height='65px'
													fileName={`diamonds/${card.name}.webp`}
												/>
											</td>
											<td>{capitalize(card.name)}</td>
											<td>
												{'$' + numberWithCommas(card.min / 1e6)} to{' '}
												{'$' + numberWithCommas(card.max / 1e6)}
											</td>
											<td>{card.percentage + '%'}</td>
											<td>{numberWithCommas(card.maxCap) + '%'}</td>
											<td>{'$' + numberWithCommas(card.sellLimit / 1e6)}</td>
											<td>
												{'$' + numberWithCommas(card.withdrawLimit / 1e6)}
											</td>
											<td>{'$' + numberWithCommas(card.limit / 1e6)}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
					<div className='col-12'>
						<div className='fw-bold fs-3'>Planner Packages</div>
					</div>
					<div className='offset-md-1 col-md-10 col-12'>
						<div className='table-responsive'>
							<table className='table table-sm myTable text-center'>
								<thead>
									<tr>
										<th></th>
										<th>Card</th>
										<th>Amount</th>
										<th>Staking Profit</th>
										<th>Max Cap</th>
										<th>Binary Daily Limit</th>
										<th>Sponsor </th>
										<th>MLM</th>
										<th>Sell Limit</th>
										<th>Withdraw Limit</th>
										<th>Transfer Limit</th>
									</tr>
								</thead>
								<tbody>
									{plannerCards.map((card, key) => (
										<tr key={key}>
											<td>
												<Image
													height='65px'
													fileName={`diamonds/${card.name}.webp`}
												/>
											</td>
											<td>{capitalize(card.name)}</td>
											<td>
												{'$' + numberWithCommas(card.min / 1e6)} to{' '}
												{'$' + numberWithCommas(card.max / 1e6)}
											</td>
											<td>{card.percentage + '%'}</td>
											<td>{numberWithCommas(card.maxCap) + '%'}</td>
											<td>
												{'$' +
													numberWithCommas(card.dailyBinaryLimit / 1e6)}
											</td>
											<td>{card.sponsor + '%'}</td>
											<td>{card.mlm + ' level(s)'}</td>
											<td>{'$' + numberWithCommas(card.sellLimit / 1e6)}</td>
											<td>
												{'$' + numberWithCommas(card.withdrawLimit / 1e6)}
											</td>
											<td>{'$' + numberWithCommas(card.limit / 1e6)}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CardsList;
